module.exports = __webpack_public_path__ + "static/img/logo-refresh.ed2f7d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/app/logo-refresh.png
// module id = 355
// module chunks = 1